import { createFileRoute, Outlet, useNavigate } from "@tanstack/react-router";
import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import { ThemeToggle } from "@/components/ui/theme-toggle";
import { PATHS } from "@/config/paths";

export const Route = createFileRoute("/_home")({
  component: HomeLayout,
});

function HomeLayout() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen relative">
      <div className="absolute top-0 left-0 p-4">
        <Button
          variant="ghost"
          onClick={() => navigate({ to: PATHS.HOME })}
          className="flex items-center gap-2 text-muted-foreground hover:text-foreground"
        >
          <ArrowLeft className="h-4 w-4" />
          Back to Chat
        </Button>
      </div>
      <div className="absolute top-0 right-0 p-4">
        <ThemeToggle />
      </div>
      <Outlet />
    </div>
  );
}
